import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from './loading.service';

export const SkipIndicator =
    new HttpContextToken<boolean>(() => false);
export const EnableSavingIndicator =
    new HttpContextToken<boolean>(() => false);
export const EnableLoadingIndicator =
    new HttpContextToken<boolean>(() => false);
export const EnablePageBlocking =
    new HttpContextToken<boolean>(() => false);

@Injectable({ providedIn: 'root' })
export class LoadingInterceptor
implements HttpInterceptor {
    constructor(private loadingService: LoadingService) {
    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        // Check for a custom attribute
        // to avoid showing loading spinner
        if (req.context.get(SkipIndicator)) {
            // Pass the request directly to the next handler
            return next.handle(req);
        }

        if (req.context.get(EnableSavingIndicator)) {
            // Turn on the saving spinner if the request has the EnableSavingIndicator attribute
            if (req.context.get(EnablePageBlocking)) {
                this.loadingService.savingOn(true);
            } else {
                this.loadingService.savingOn();
            }
        } else if (req.context.get(EnableLoadingIndicator)) {
            this.loadingService.loadingOn();
        } else if (req.method === 'GET') {
            // Turn on the loading spinner, but only for GET requests
            this.loadingService.loadingOn();
        }

        return next.handle(req).pipe(
            finalize(() => {
                // Turn off the loading spinner
                this.loadingService.loadingOff();
                this.loadingService.savingOff();
            })
        );
    }
}
